import React, { useState, useEffect } from "react";
import { FaWhatsapp } from "react-icons/fa";
import config from "../data/siteConfig";
import useReveal from "../hooks/useReveal";

import RateBar from "../components/RateBar";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Stats from "../components/Stats";
import About from "../components/About";
import TagMarquee from "../components/TagMarquee";
import Categories from "../components/Categories";
import Gallery from "../components/Gallery";
import Reels from "../components/Reels";
import OurShop from "../components/OurShop";
import WeddingCollection from "../components/WeddingCollection";
import GetInTouch from "../components/GetInTouch";
import Visit from "../components/Visit";
import Footer from "../components/Footer";

export default function Home() {
  // Rates start from the defaults in siteConfig, then get replaced by the
  // live values from the rate panel (rate.shreeabhushanjewellers.com).
  const [rates, setRates] = useState(config.rates);
  const [activeCat, setActiveCat] = useState("all");

  useReveal();

  useEffect(() => {
    if (!config.ratesApi) return;
    let active = true;

    const load = () => {
      fetch(config.ratesApi, { cache: "no-store" })
        .then((r) => (r.ok ? r.json() : Promise.reject(new Error("bad status"))))
        .then((data) => {
          if (active && data && data.gold22k) {
            setRates((prev) => ({ ...prev, ...data }));
          }
        })
        .catch(() => {
          /* API unreachable — keep showing the last known / default rates */
        });
    };

    load(); // fetch immediately on load

    // poll every N seconds so updates appear without a manual refresh
    const everyMs = (config.ratesPollSeconds || 60) * 1000;
    const timer = setInterval(load, everyMs);

    // also refresh the moment the visitor returns to the tab
    const onVisible = () => {
      if (document.visibilityState === "visible") load();
    };
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      active = false;
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  return (
    <>
      <RateBar rates={rates} />
      <Header />
      <Hero />
      <Stats />
      <About />
      <TagMarquee />
      <Categories onSelect={setActiveCat} />
      <Gallery activeCat={activeCat} setActiveCat={setActiveCat} />
      <Reels />
      <OurShop />
      <WeddingCollection />
      <GetInTouch />
      <Visit />
      <Footer />

      <a
        href={`https://wa.me/${config.contact.whatsapp}`}
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp"
        className="fixed bottom-6 right-6 z-[80] flex h-14 w-14 items-center justify-center rounded-full border-2 border-white bg-[#25d366] text-3xl text-white shadow-vintage transition-transform duration-200 hover:scale-110"
      >
        <FaWhatsapp />
      </a>
    </>
  );
}
